import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import './ConfigDialog_FAQ_ParentOrder.scss';
import { Q_SortableList } from '@app/hcs-frontend';
import { ConfigKeyFE_FAQ_ParentOrder, ModuleFE_FAQ } from '../../../_entity.js';
import { DropDown_FAQ } from '../../../_entity/frequently-asked-question/ui-components.js';
import { ConfigKey_FAQ_ParentOrder, FAQType_Parent } from '@app/advisor-ui-shared';
export class ConfigDialog_FAQ_ParentOrder extends ComponentSync {
    // ######################## Static ########################
    static show() {
        const model = {
            dialogKey: ConfigKey_FAQ_ParentOrder,
            closeOverlayOnClick: () => true,
            content: _jsx(ConfigDialog_FAQ_ParentOrder, {}),
        };
        ModuleFE_Dialog.show(model);
    }
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.parentIds ??= ConfigKeyFE_FAQ_ParentOrder.get() ?? [];
        return state;
    }
    // ######################## Logic ########################
    closeDialog = () => {
        ModuleFE_Dialog.close();
    };
    onOrderChange = async (ids) => {
        const newIds = [...ids];
        await ConfigKeyFE_FAQ_ParentOrder.set(newIds);
        this.setState({ parentIds: newIds });
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { id: 'config-dialog__faq-parent-order', className: 'config-dialog', children: [this.render_Title(), this.render_Content()] });
    }
    render_Title = () => {
        return _jsxs(LL_H_C, { className: 'config-dialog__title', children: ["Editor - FAQ Parent Order", _jsx(ICONS.x.component, { className: 'config-dialog__title-icon', onClick: this.closeDialog })] });
    };
    render_Content = () => {
        const ids = this.state.parentIds;
        return _jsxs("div", { className: 'config-dialog__content', children: [_jsx(Q_SortableList, { items: ids, onChange: this.onOrderChange, itemRenderer: id => this.render_FAQ(id, () => this.onOrderChange(ids.filter(item => item !== id))) }), _jsx(DropDown_FAQ.selectable, { selected: undefined, canUnselect: false, queryFilter: faq => faq.type === FAQType_Parent && !ids.includes(faq._id), onSelected: faq => {
                        ids.push(faq._id);
                        return this.onOrderChange(ids);
                    } })] });
    };
    render_FAQ = (id, onDelete) => {
        const faq = ModuleFE_FAQ.cache.unique(id);
        return _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), _jsx("div", { className: 'faq-parent-order__faq-label', children: faq?.label ?? 'N/A' })] });
    };
}
//# sourceMappingURL=ConfigDialog_FAQ_ParentOrder.js.map